import React from 'react';
// @ts-ignore
import styles from './CaseCloseComponent.module.scss';
import Text from '../../../Components/Base/Text/Text';
import Button from '../../../Components/Button/Button';
import { Theme } from '../../../Enums/Theme.enum';
import ApiClient from '../../../Services/ApiClient';
import { useState } from 'react';
import MedicalReportDetailModal from '../../../Components/MedicalReport/MedicalReportDetailModal';
import { useAppContext } from '../../../Services/AppContext';
import RadioListField from '../../../Components/Form/components/RadioListField';
import FormWrapper from '../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import {
	useCaseMedicalReportsQuery,
	useLazyCaseMedicalReportsQuery,
} from '../../../graphql/graphql';
import { useEffectAsync } from '../../../helpers';
import Loading from '../../../Components/Loading';
import OverlayLoading from '../../../Components/OverlayLoading';
import FullPageLoading from '../../../Components/Utils/FullPageLoading/FullPageLoading';

interface CaseCloseComponentProps {
	caseId: string;
	patientId: string;
	onClose: () => void;
	onCaseClose: () => void;
}

const CREATE_REPORT_OPTIONS = [
	{
		title: 'base.yes',
		value: 'yes',
	},
	{
		title: 'base.no',
		value: 'no',
	},
];

const CaseCloseComponent: React.FC<CaseCloseComponentProps> = ({
	caseId,
	patientId,
	onClose,
	onCaseClose,
}) => {
	const [addCaseLength, setAddCaseLength] = useState<boolean>(false);
	const { userData, isMou, workplaceId } = useAppContext();
	const [forceMedicalReport] = useState(isMou);
	const [medicalReportOpened, setMedicalReportOpened] =
		useState<boolean>(forceMedicalReport);
	const [getCaseMedicalReports] = useLazyCaseMedicalReportsQuery();
	const [hasMedicalReport, setHasMedicalReport] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [isFullPageLoading, setIsFullPageLoading] = useState(false);

	const handleCloseCase = async (ignoreSending?: boolean) => {
		setIsFullPageLoading(true);
		await ApiClient.put('/cases/' + caseId + '/solve', {
			note: '',
			ignoreSending: ignoreSending ?? true,
			addCaseLength: addCaseLength,
		});
		onCaseClose();
		setIsFullPageLoading(false);
	};

	const handleCancel = () => {
		onClose();
	};

	const handleCreateMedicalReport = () => {
		setMedicalReportOpened(true);
	};

	const handleCancelCreateMedicalReport = () => {
		setMedicalReportOpened(false);

		if (forceMedicalReport) {
			onClose();
		}
	};

	const handleConfirm = async () => {
		if (
			!hasMedicalReport &&
			formMethods.getValues('createMedicalReport') === 'yes'
		) {
			handleCreateMedicalReport();
		} else {
			await handleCloseCase(false);
		}
	};

	useEffectAsync(async () => {
		const data = await getCaseMedicalReports({
			id: caseId,
		}).unwrap();
		for (const medicalReport of data?.case?.medicalReports || []) {
			if (medicalReport?.workplaceId === workplaceId) {
				setHasMedicalReport(true);
			}
		}
		setTimeout(() => {
			setIsLoading(false);
		}, 500);
	}, []);

	const formMethods = useForm({
		defaultValues: {
			createMedicalReport: 'yes',
			addCaseLength: true,
		},
	});

	if (isFullPageLoading) {
		return <FullPageLoading />;
	}

	if (isLoading) {
		return <Loading />;
	}

	return (
		<>
			{!forceMedicalReport && (
				<div className={styles.wrapper}>
					{!hasMedicalReport && (
						<div className={styles.content}>
							<Text
								tx={
									'component.caseCloseComponent.doYouWannaCreateMedicalReport'
								}
								className={styles.text}
							/>
							<FormWrapper formMethods={formMethods}>
								<RadioListField
									name='createMedicalReport'
									isRequired
									data={CREATE_REPORT_OPTIONS}
									inLine
								/>
								{/*
                    <FormControl name="addCaseLength" hideRequired={true}
                                 onChange={() => setAddCaseLength(prev => !prev)}>
                        <Checkbox tx={'component.caseCloseComponent.addCaseLengthToDiscourse'} value={addCaseLength}/>
                    </FormControl>
                     */}
							</FormWrapper>
						</div>
					)}
					<div className={hasMedicalReport ? styles.content : undefined}>
						<Text
							tx={'component.caseCloseComponent.messageFromCase'}
							inline={true}
							className={styles.text}
						/>
						<div className={styles.controls}>
							<Button
								onClick={handleConfirm}
								title={'base.yes'}
								theme={Theme.GREEN}
							/>
							<Button
								onClick={handleCancel}
								title={'base.no'}
								theme={Theme.RED}
							/>
						</div>
					</div>
				</div>
			)}
			<MedicalReportDetailModal
				opened={medicalReportOpened}
				onClose={handleCancelCreateMedicalReport}
				onMedicalReportCreate={handleCloseCase}
				workplaceId={userData.workplaceId}
				patientId={patientId}
				loggedUserId={userData.id}
				caseId={caseId}
			/>
		</>
	);
};

export default CaseCloseComponent;
